export default __webpack_public_path__ + "a19a8d9f7071c1ff8f6671c9fa95738e.svg";